import { ErrorHandler, Provider } from '@angular/core';
import { GlobalErrorHandler } from './global-error-handler';

export function provideLogging(): Provider[] {
  return [
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
  ];
}

/**
 * Logging Configuration Options
 * Các tùy chọn cấu hình cho logging system
 */
export interface LoggingConfig {
  /**
   * Enable/disable logging to IndexedDB
   * Default: true
   */
  enableIndexedDB: boolean;

  /**
   * Enable/disable console logging
   * Default: true in development, false in production
   */
  enableConsole: boolean;

  /**
   * Maximum number of logs to keep in IndexedDB
   * Default: 10000
   */
  maxLogs: number;

  /**
   * Auto-clean logs older than X days
   * Default: 30 days
   */
  autoCleanDays: number;

  /**
   * Batch size for flushing logs to IndexedDB
   * Default: 50
   */
  batchSize: number;

  /**
   * Flush interval in milliseconds
   * Default: 1000ms (1 second)
   */
  flushInterval: number;

  /**
   * Categories to exclude from logging
   * Default: []
   */
  excludeCategories: string[];

  /**
   * Minimum log level to record
   * Default: 'DEBUG'
   */
  minLogLevel: 'DEBUG' | 'INFO' | 'WARN' | 'ERROR' | 'FATAL';
}

/**
 * Default logging configuration
 */
export const DEFAULT_LOGGING_CONFIG: LoggingConfig = {
  enableIndexedDB: true,
  enableConsole: true,
  maxLogs: 10000,
  autoCleanDays: 30,
  batchSize: 50,
  flushInterval: 1000,
  excludeCategories: [],
  minLogLevel: 'DEBUG',
};

/**
 * Log levels with priority
 */
export const LOG_LEVELS = {
  DEBUG: 0,
  INFO: 1,
  WARN: 2,
  ERROR: 3,
  FATAL: 4,
} as const;

/**
 * Common log categories
 */
export const LOG_CATEGORIES = {
  SYSTEM: 'SYSTEM',
  API: 'API',
  CART: 'CART',
  ORDER: 'ORDER',
  CUSTOMER: 'CUSTOMER',
  PAYMENT: 'PAYMENT',
  AUTH: 'AUTH',
  NAVIGATION: 'NAVIGATION',
  PERFORMANCE: 'PERFORMANCE',
  ANGULAR: 'ANGULAR',
  JAVASCRIPT: 'JAVASCRIPT',
  ASYNC: 'ASYNC',
} as const;

/**
 * Common error types
 */
export const ERROR_TYPES = {
  RUNTIME_ERROR: 'RUNTIME_ERROR',
  HTTP_ERROR: 'HTTP_ERROR',
  PROMISE_REJECTION: 'PROMISE_REJECTION',
  CHANGE_DETECTION_ERROR: 'CHANGE_DETECTION_ERROR',
  NULL_REFERENCE_ERROR: 'NULL_REFERENCE_ERROR',
  TYPE_ERROR: 'TYPE_ERROR',
  STACK_OVERFLOW_ERROR: 'STACK_OVERFLOW_ERROR',
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  BUSINESS_LOGIC_ERROR: 'BUSINESS_LOGIC_ERROR',
} as const;
